
namespace RioERP.Masters {
    export class ModeColumns {
        static columnsKey = 'Masters.Mode';
    }
}